<template>
  <div v-if="activePeripheral && activePeripheral.device_type_name !== 'Display'">
    <v-card
        v-if="activePeripheral.manufacturer !== ''"
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Manufacturer</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ activePeripheral.manufacturer }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider v-if="activePeripheral.manufacturer !== ''"/>
    <v-card
        v-if="activePeripheral.model !== ''"
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Model</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ activePeripheral.model }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider v-if="activePeripheral.model !== ''"/>
    <v-card
        v-if="activePeripheral.communication_protocol !== ''"
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Communication Protocol</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ activePeripheral.communication_protocol.toUpperCase() }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider  v-if="activePeripheral.communication_protocol !== ''"/>
    <v-card
        v-if="activePeripheral.currency !== ''"
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Currency</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ activePeripheral.currency }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider v-if="activePeripheral.currency !== ''"/>
    <v-card
        v-if="activePeripheral.serial_number !== ''"
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Serial Number</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ activePeripheral.serial_number }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider v-if="activePeripheral.serial_number !== ''"/>
    <v-card
        v-if="activePeripheral.firmware !== ''"
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Firmware</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ activePeripheral.firmware }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider v-if="activePeripheral.firmware !== ''"/>
    <v-card
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Status</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular d-flex align-center">
          <v-icon v-if="peripheralFaulty" class="mr-1" size="18" color="#FF5252">{{ alertIcon }}</v-icon>
          {{ peripheralStatusText }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider/>
    <v-card
        v-if="activePeripheral.protocol_details !== '' && activePeripheral.protocol_details"
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Protocol Details</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ activePeripheral.protocol_details }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider v-if="activePeripheral.protocol_details"/>
    <div class="py-4 pl-4">
      <CommentBox @comment-submitted="receiveCommentEmit"/>
      <v-row  v-for="(item, i) in sortedPeripheralComments" :key="i">
          <v-col class="my-0 py-0">
            <CommentItem @delete-comment="receiveCommentDeleteAction" :data="item"/>
          </v-col>
      </v-row>
    </div>
  </div>
  <div class="pl-4 py-4" v-else-if="activePeripheral && activePeripheral.device_type_name === 'Display'">
      <CommentBox @comment-submitted="receiveCommentEmit"/>
      <v-row  v-for="(item, i) in sortedPeripheralComments" :key="i">
          <v-col class="my-0 py-0">
            <CommentItem @delete-comment="receiveCommentDeleteAction" :data="item"/>
          </v-col>
      </v-row>
  </div>
  <div v-else>
    <v-card
        height="72"
        class="pl-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Peripherals</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ (device && Array.isArray(device.displays) ? device.displays.length : 0) }} displays, {{ (device && Array.isArray(device.peripherals) ? device.peripherals.length : 0) }} misc
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider/>
    <v-card
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Primary Display</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ (device && Array.isArray(device.displays) && device.displays.find(display => display.primary === true)) ? device.displays.find(display => display.primary === true).name : 'None' }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider/>
    <v-card
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Configured Apps</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ totalApplications }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider/>
    <v-card
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Disabled Displays</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ getDisabledDisplays(device) }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
    <v-divider/>
    <v-card
        height="72"
        class="px-4 pb-5 pt-3 "
        flat>
      <v-card-text class="pa-0">
        <span class="subtitle-2 mb-2 text-secondary font-weight-regular d-block">Disabled Misc</span>
        <v-list-item-title class="subtitle-2 text-primary font-weight-regular">
          {{ getDisabledMisc(device) }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Devices from '../../../../services/api/Devices';
import CommentBox from '../../../Comments/CommentBox.vue';
import CommentItem from '../../../Comments/CommentItem.vue';
import peripheralStatus from '../../../../mixins/peripheralStatus';
import {mdiAlert} from '@mdi/js';

export default {
  name: "PeripheralInfo",
  mixins: [peripheralStatus],
  components: {
    CommentBox,
    CommentItem
    
  },
  props: ['device'],
  data: function () {
    return {
       peripheral: {},
       commentValue: "",
       alertIcon: mdiAlert
    }
  },
  watch: {
  activePeripheral: {
    handler(val){
      this.peripheral = val || {};

      const device_uuid = this.device && this.device.uuid;
      if(!val || !val.uuid || !device_uuid)
        {
          this.$store.commit('devices/SET_PERIPHERAL_COMMENTS', []);
          return;
        }

      if(val.device_type_name === 'Display')
        {
          this.getDisplayComments(device_uuid, val.uuid);
        }
      else
        {
          this.getPeripheralsComment(device_uuid, val.uuid);
        }
    },
  },
  },
  computed: {
    ...mapGetters({ activePeripheral: "devices/activePeripheral", peripheralCommentsGetter: "devices/peripheralCommentsGetter"}),
    sortedPeripheralComments() {
      // Sort descending by created_at (latest first)
      if (!this.peripheralCommentsGetter || !Array.isArray(this.peripheralCommentsGetter)) return [];
      return [...this.peripheralCommentsGetter].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    },
    peripheralFaulty() {
      return this.isPeripheralFaulty(this.activePeripheral);
    },
    peripheralStatusText() {
      return this.peripheralStatusLabel(this.activePeripheral);
    },
    cardReader(){
      return this.activePeripheral.device_type_name;
    },
    totalApplications() {
      // Defensive: Check if displays exists and is array
      if (!this.device || !Array.isArray(this.device.displays)) return 0;
      if (this.device.displays.length > 1) {
        return this.device.displays.reduce((total, display) => {
          return total + (display.applications ? display.applications.length : 0);
        }, 0);
      } else if (this.device.displays.length === 1) {
        return this.device.displays[0].applications ? this.device.displays[0].applications.length : 0;
      }
      return 0; // Default return if no displays are found
    }
  },
  mounted(){
    // Defensive: Only call if device and its arrays exist
    if (this.device && Array.isArray(this.device.displays)) {
      this.getDisabledDisplays(this.device);
    }
    if (this.device && Array.isArray(this.device.peripherals)) {
      this.getDisabledMisc(this.device);
    }
  },
  methods: {
    getDisabledDisplays(device) {
      if (!device || !Array.isArray(device.displays)) return "None";
      return device.displays.filter(display => display.disabled === true).map(display => display.name).join(", ") || "None";
    },
    getDisabledMisc(device) {
      if (!device || !Array.isArray(device.peripherals)) return "None";
      return device.peripherals.filter(peripheral => peripheral.enabled === false).map(peripheral => peripheral.name).join(", ") || "None";
    },
    getDisplayComments(device_uuid, peripheral_uuid){
      try {
        Devices.getCommentDisplay(device_uuid, peripheral_uuid).then(response => {
          this.$store.commit('devices/SET_PERIPHERAL_COMMENTS', response.data.comments)
        }) 
      } catch (error) {
        console.log(error)
      }
    }, 
    getPeripheralsComment(device_uuid, peripheral_uuid){
      try {
        Devices.getCommentPeripheral(device_uuid, peripheral_uuid).then(response => {
          this.$store.commit('devices/SET_PERIPHERAL_COMMENTS', response.data.comments);
        })
        } catch (error) {
          console.log(error);
      }
    },
    receiveCommentEmit(data){
      if(this.peripheral.device_type_name === 'Display'){
        let uuid = this.$props.device.uuid;
        let display_uuid = this.peripheral.uuid;
        Devices.addCommentDisplay(uuid, display_uuid, data).then(()=>{
          this.getDisplayComments(this.$props.device.uuid, this.peripheral.uuid);
        })
      }
      else {
       let device_uuid = this.$props.device.uuid;
       let peripheral_uuid =  this.peripheral.uuid;
       Devices.addCommentPeripheral(device_uuid, peripheral_uuid, data).then(()=>{
          this.getPeripheralsComment(this.$props.device.uuid, this.peripheral.uuid);
        })
      }
    },
    receiveCommentDeleteAction(data){
      if(this.peripheral.device_type_name === 'Display'){
        let display_uuid = this.peripheral.uuid;
        let comment_uuid = data;
        Devices.deleteCommentDisplay(display_uuid, comment_uuid).then(()=>{
          this.getDisplayComments(this.$props.device.uuid, this.peripheral.uuid);
        })
      }
      else {
       let peripheral_uuid = this.peripheral.uuid;
       let comment_uuid =  data;
       Devices.deleteCommentPeripheral(peripheral_uuid, comment_uuid).then(()=>{
          this.getPeripheralsComment(this.$props.device.uuid, this.peripheral.uuid);
        })
      }
    },
  }
}
</script>

<style scoped>

</style>